import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';
import { WorkspaceUser, InviteUserRequest, ChangeRoleRequest } from '../models/users';
import { WorkspaceUserService } from '../services/user.service';

const mockWorkspaceUsers: WorkspaceUser[] = [
  {
    id: 'user-001',
    email: 'alice.admin@example.com',
    role: 'admin',
    status: 'active',
    invited_by: 'system'
  },
  {
    id: 'user-002',
    email: 'bob.member@example.com',
    role: 'editor',
    status: 'active',
    invited_by: 'user-001'
  },
  {
    id: 'user-003',
    email: 'charlie.pending@example.com',
    role: 'editor',
    status: 'pending',
    invited_by: 'user-001'
  }
];

@Injectable()
export class MockWorkspaceUserService extends WorkspaceUserService implements WorkspaceUserService {
  public override inviteUser(workspaceId: string, data: InviteUserRequest): Observable<void> {
    console.log(`MOCK: Inviting user ${data.email} as ${data.role} to workspace ${workspaceId}`);

    const newUserId = `user-temp-${Date.now()}`;
    const newUser: WorkspaceUser = {
      id: newUserId,
      email: data.email,
      role: data.role,
      status: 'pending',
      invited_by: 'current-mock-user'
    };
    mockWorkspaceUsers.push(newUser);

    return of(undefined).pipe(delay(2000));
  }

  public override getUsers(workspaceId: string): Observable<WorkspaceUser[]> {
    console.log(`MOCK: Retrieving users for workspace ${workspaceId}`);
    return of([...mockWorkspaceUsers]).pipe(delay(2000));
  }

  public override revokeAccess(workspaceId: string, userId: string): Observable<void> {
    console.log(`MOCK: Revoking access for user ${userId} from workspace ${workspaceId}`);
    const index = mockWorkspaceUsers.findIndex(u => u.id === userId);
    if (index > -1) {
      mockWorkspaceUsers.splice(index, 1);
    }
    return of(undefined).pipe(delay(2000));
  }

  public override changeRole(workspaceId: string, userId: string, data: ChangeRoleRequest): Observable<void> {
    console.log(`MOCK: Changing role for user ${userId} in workspace ${workspaceId} to ${data.role}`);

    return of(undefined).pipe(delay(2000));
  }
}
